import axios from "axios";
import baseUrlApi from "../lib/baseUrlApi";
import baseUrlWeb from "../lib/baseUrlWeb";
import { useCookies } from 'react-cookie';

interface GetSettingParams {
    siteRecno: string,
    siteId: string,
}
let requesting = false;
let requestingKey = null;
let activeRequestCount  = 0;

export const ApiRequest = {
    getMailAddress: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getMailAddress";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registGateway: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registGateway";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registGatewaySensor: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registGatewaySensor";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registSensor: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registSensor";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registSensorSetting: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registSensorSetting";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registInfo: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registInfo";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registSensorInfo: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registSensorInfo";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registSiteManage: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registSiteManage";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registSiteSetting: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registSiteSetting";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    registMailAddress: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/registMailAddress";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getSensorSetting: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getSensorSetting";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getSiteManage: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getSiteManage";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getGraphData: async (params: any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getGraphData";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    postDataDownloadBlob: async(params:any, token: string, callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/dataDownload";
        const config = {
            responseType: 'blob',
        }
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback, config);
    },
    postLogin: async (params:any, token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlWeb + "/login";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    postLogout: async (token: string,　callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/logout";
        return await ApiRequest.baseApiRequest(url, token, null, callback, errorCallback);
    },
    getDashBoard: async(params: any, token: string, callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getDashboardData";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getGateway: async (params:any, token: string, callback : Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getGateway";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getGatewaySensor: async(params:any, token: string, callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getGatewaySensor";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getSensor: async(params: any, token: string, callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getSensor";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getInfo: async(params: any, token: string, callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getInfo";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getLoginInfo: async(params: any, token: string, callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getLoginInfo";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getSite: async(params: any, token: string,callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getSite";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getSiteEq: async(params: any, token: string,callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getSiteEq";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    getSiteSetting: async(params: any, token: string,callback: Function, errorCallback: Function) => {
        let url = baseUrlApi + "/getSiteSetting";
        return await ApiRequest.baseApiRequest(url, token, params, callback, errorCallback);
    },
    baseApiRequest: async(url:string, token: string, params: any, callback: Function, errorCallback: Function, config:any = {}) => {
        config["headers"] = {
            Authorization: `Bearer ${token}`
        }
        const loader = document.getElementById('loaderScreen');

        activeRequestCount++;
        if (loader && activeRequestCount === 1) {
            loader.style.display = 'block';
        }
        return await axios.post(
            url,
            params,
            config,
        ).then(response => {
            activeRequestCount--;
            if (loader && activeRequestCount === 0) {
                loader.style.display = 'none';
            }
            callback(response);
        }).catch(error => {
            activeRequestCount--;
            if (loader && activeRequestCount === 0) {
                loader.style.display = 'none';
            }
            errorCallback(error)
        });
    }
};
